var map = {
	"./decidim/avatar-multiuser.png": 90868,
	"./decidim/brands/facebook.svg": 42170,
	"./decidim/brands/google.svg": 74907,
	"./decidim/brands/twitter-x.svg": 41064,
	"./decidim/cc-badge.png": 69302,
	"./decidim/decidim-logo.svg": 72918,
	"./decidim/default-avatar.svg": 22066,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 29142,
	"./decidim/icons.svg": 50149,
	"./decidim/pattern.png": 42290,
	"./decidim/placeholder-card-g.svg": 45599,
	"./decidim/placeholder-card-l.svg": 88772,
	"./decidim/placeholder.jpg": 34683,
	"./decidim/remixicon.symbol.svg": 63699,
	"./decidim/vendor/social-share-button/douban.svg": 50498,
	"./decidim/vendor/social-share-button/email.svg": 39103,
	"./decidim/vendor/social-share-button/facebook.svg": 42177,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 56659,
	"./decidim/vendor/social-share-button/hacker_news.svg": 17939,
	"./decidim/vendor/social-share-button/linkedin.svg": 71023,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 30504,
	"./decidim/vendor/social-share-button/pinterest.svg": 12753,
	"./decidim/vendor/social-share-button/reddit.svg": 66657,
	"./decidim/vendor/social-share-button/telegram.svg": 55288,
	"./decidim/vendor/social-share-button/tumblr.svg": 94287,
	"./decidim/vendor/social-share-button/twitter.svg": 55086,
	"./decidim/vendor/social-share-button/vkontakte.svg": 64176,
	"./decidim/vendor/social-share-button/wechat.svg": 18203,
	"./decidim/vendor/social-share-button/whatsapp.svg": 80371,
	"./decidim/vendor/social-share-button/x.svg": 22551,
	"./decidim/vendor/social-share-button/xing.svg": 72513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84527;